var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2133_24709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.10303 3.92488V2.15955",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71777 3.92488V2.15955",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33252 3.92488V2.15955",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6785 3.04224H2.75706C2.45976 3.04224 2.21875 3.30569 2.21875 3.63068V9.22089C2.21875 9.54588 2.45976 9.80934 2.75706 9.80934H8.6785C8.9758 9.80934 9.21681 9.54588 9.21681 9.22089V3.63068C9.21681 3.30569 8.9758 3.04224 8.6785 3.04224Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8335 5.98438H7.60168",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8335 7.74976H5.98675",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2133_24709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.53637,
    height: 8.23821,
    fill: "white",
    transform: "translate(1.94971 1.86536)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidityIcon);
export default __webpack_public_path__ + "static/media/ValidityIcon.1203cf51de84f06f891f812e853a1785.svg";
export { ForwardRef as ReactComponent };